import React from "react";
import { Box } from "@mui/material";
import { observer } from "mobx-react";
import AcxSelect from "components/UI/Select/BaseSelectComponents/AcxSelect";
import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";
import {
    SelectedTargetFields,
    SourceFieldType,
    TargetFieldOptions,
} from "../types";
import {
    arrowStyles,
    fieldStyles,
    getDefaultValue,
    selectCustomStyle,
} from "../helpers/componentUtils";
import CustomOption from "../components/CustomOption";

type MapFieldProps = {
    sourceField: SourceFieldType;
    sourceFieldOptions: { label: string; value: string }[];
    getUpdatedTargetFields: () => {
        targetFieldOptions: TargetFieldOptions;
        selectedTargetFields: SelectedTargetFields;
    };
    updateSourceFields: (
        fieldId: string,
        key: string,
        value: string | boolean,
        targetFieldId?: string,
    ) => void;
};

const MapField: React.FC<MapFieldProps> = observer(
    ({
        sourceField,
        sourceFieldOptions,
        getUpdatedTargetFields,
        updateSourceFields,
    }) => {
        const { id, alias } = sourceField;

        const { targetFieldOptions, selectedTargetFields } =
            getUpdatedTargetFields();

        const defaultValue = getDefaultValue({
            id,
            selectedTargetFields,
            targetFieldOptions,
        });

        return (
            <Box key={id} sx={fieldStyles}>
                <AcxSelect
                    customStyle={selectCustomStyle({ flex: 15 })}
                    fullWidth
                    id={`source-field-${id}`}
                    options={sourceFieldOptions}
                    placeholder="Select"
                    defaultValue={sourceFieldOptions.find(
                        (e) => e.label === alias,
                    )}
                />
                <ArrowForwardOutlinedIcon sx={arrowStyles} />
                <AcxSelect
                    optionComponent={CustomOption}
                    onChange={(e) => {
                        // The no selection option has an empty value
                        updateSourceFields(
                            id,
                            "targetFieldName",
                            e.value === "" ? "" : e.label,
                            e.id,
                        );
                    }}
                    customStyle={selectCustomStyle({ flex: 15 })}
                    id={`target-field-${id}`}
                    options={targetFieldOptions.grouped}
                    placeholder="Select"
                    defaultValue={defaultValue}
                />
            </Box>
        );
    },
);

export default MapField;
